import { render, staticRenderFns } from "./RefundHistory.template.vue?vue&type=template&id=1a9a36a4&scoped=true&"
var script = {}
import style0 from "./RefundHistory.template.vue?vue&type=style&index=0&id=1a9a36a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a36a4",
  null
  
)

export default component.exports